module.exports = __webpack_public_path__ + "static/img/qd2.e4c9ba2c.png";